/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useRef,useCallback,useEffect } from 'react'
import '../assets/styles/modal.scss'
import deleteIcon from "../assets/delete.svg";
import closeIcon from '../images/icons/Icon2.png'
import { APIEndpoint } from "../utils/axios";
import { useTranslation } from 'react-i18next';
import CustomSelect from './CustomSelect';
import {TypeOptions} from '../utils/configs';
import { Loading } from './Loading';

export const Mapping = (props) => {
  const { t } = useTranslation();
  let count = 0;
let selecRef=useRef(null);
  let isError = false;
  let updateStatusText = '';

  if (props.modalFormStatusObj) {
    if ( ('text' in props.modalFormStatusObj)) {
      updateStatusText = props.modalFormStatusObj.text;
    }
    if ( ('error' in props.modalFormStatusObj)) {
      isError=props.modalFormStatusObj.error;
    }
  }
  useEffect(() => {
 if(props.loading && props.modalFormStatusObj){
  props.setLoading(false);
 }
  }, [props.loading])

  function checkValidFields(){
    const enableButton=props?.form?.some(item=>(item.kind==='item' && !item.id)||item.quantity===null|| (item.kind==='category' && !item.category));
    return enableButton;
  }
  return (
      <div className="overlay" role="dialog">
   <div className="dialog sm-scrollbar">
        <div className="dialog__content">
          <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={props.onClose} />
          <h2 className="dialog__title subheading-text-medium fontMedium">{props.data.title.itemName}</h2>
          <hr />
<> {!props?.loading?<div className="dialog__footer flexRow justifyContentSpaceBetween flexWrap">
          <div className='width100'>
          <table id="mapping-table">
            <tr className='sticky'>
              <th style={{width:"160px",textAlign:'center'}}>Type</th>
              <th style={{width:"280px",textAlign:'center'}}>Name</th>
              <th style={{textAlign:'center',width:'85px'}}>Quantity</th>
              <th style={{width:"150px",textAlign:'center'}}>Important</th>
              <th style={{width:"120px",textAlign:'center'}}>Actions</th>
            </tr>
            {
 props.form.length > 0 ? (
    props.form.map((_, index) => {
      count = index;
      return (
        <tr key={index} id={`map` + index}>
          <input type="hidden" name={"itemId"} value={_.id} />
          <input type="hidden" name={"itemType"} value={_.itemType} />
            <td>
               <div className={`dialog__container_item input-container`}>
                <div className={`dialog__description`}>
                <select
                name="type"
                className="padding4 edit-input"
                value={_.kind}
                onChange={(e) => props.handleChange(e, index)}
                >
                {
                TypeOptions.map((_, index) => {
                return (
                <option value={_.value}

                key={index}>{_.label}</option>
                )
                })
                }
                </select>
                </div>
               </div>
          </td>
         {(_.kind === 'item' || _.kind == null) ? <td>
            <button className='flexRow justifyContentFlexEnd saleType-div'>
              <CustomSelect
                ref={selecRef}
                options={props.itemListArray}
                placeHolder={'Start typing a serving name...'}
                width={'17rem'}
                value={props.itemListArray?.filter(option => _.id && _.id === option.value)}
                onChange={(e) => props.handleChange(e, index,'itemName')}
              />
            </button>
          </td>:
           <td>
           <button className='flexRow justifyContentFlexEnd saleType-div'>
             <CustomSelect
               ref={selecRef}
               options={props.catPol}
               placeHolder={'Start typing a category name...'}
               width={'17rem'}
               value={props.catPol?.filter(option => _.category?.value && _.category.value === (option.subCatId ?? option.catId))}
               onChange={(e) => props.handleChange(e, index,'category')}
             />
           </button>
         </td>}
          <td>
            <input type="number" name={"quantity"} className='padding4 edit-input' placeholder={_.quantity} onChange={(e) => props.handleChange(e, index)} />
          </td>
          <td style={{ width: "100px",textAlign:'center' }}>
            <div className={_.important ? 'combo-select-true' : 'combo-select-false'}>
              <div className='flexRow justifyContentFlexStart dialog__description__checkbox'>
                <input
                  id={index}
                  name={"important"}
                  type='checkbox'
                  defaultChecked={_.important}
                  value={_.important}
                  onClick={(e) => props.handleChange(e, index)}
                />
              </div>
              <div id={"important-span" + index}> {_.important ? 'Yes' : 'No'}</div>
            </div>
          
          </td>
          <td style={{ width: "100px",textAlign:'center' }}>
          <button className='flexRow justifyContentCenter alignItemsCenter width100 hor-ctr space-btn menu-item-head'>
              <img className='icon-size-role-del' alt='delete' title='Delete' onClick={() => props.onDeleteMapping(index)} src={deleteIcon} />
            </button>
          </td>
        </tr>

      );
    })
  ):(
    <tr>
      <td colSpan="5" style={{ textAlign: 'center', padding: '1rem' }}>
        <strong>No mappings added.</strong>
      </td>
    </tr>
  )
}

          </table>
      </div>
          </div>:<Loading/>}</>
    

          {updateStatusText ?
          <>
            <div className={ "dialog__statusBlock " + (isError ? 'alert_error' : 'alert_success') }>
              {updateStatusText}
            </div>
          </> : null }
        </div>
    <div className="dialog__footer flexRow justifyContentSpaceEvenly pb-4">
          <button className="uploadImage-button" value={count} onClick={props.onAddServings}>{t('pages.productsContent.manageCombos.addServing')}</button>
          <button type="submit" value={props.data.title.itemId} disabled={checkValidFields()} className="done-button" onClick={props.onSubmit}>{t('pages.productsContent.manageCombos.saveChanges')}</button>
        </div>
      </div>
    </div>
  );
}
export const MappingModal = (props) => {
  const[loading,setLoading]=useState(false);
  const [itemsList, setItemsList] = useState([]);
  const [catPol, setCatPol] = useState([]);
  const [itemListArray, setItemListArray] = useState([]);
  const [form, setForm] = useState([]);


  React.useEffect(() => {
    fetchItemList();
  }, []);
  React.useEffect(() => {
    if(itemsList.length){
    const options = [];
    itemsList.forEach( (fieldValue, index) => {
      options.push({key: index+1, label: fieldValue.itemName, value: fieldValue.itemId});
    });
    setItemListArray(options );

    }
  }, [itemsList]);

  const onSubmit = (e) => {
    setLoading(true);
    const output = form.map(entry => {
        const isItem = entry.kind === 'item';
    
        const target = isItem
          ? {
              kind: 'item',
              id: Number(entry.id),
              name: entry.itemName,
              itemType: entry.itemType,
              path: []
            }
          : {
              kind: 'category',
              id: Number(entry.category.catId),
              name: entry.category.label,
              path: entry.subCategory
                ? [{
                    id: Number(entry.subCategory.subCatId),
                    name: entry.subCategory.label
                  }]
                : []
            };
    
        return {
          target,
          quantity: entry.quantity,
          important: entry.important
        };
      });
    
    const mode=props.title;
    const updated = output;
    removeContainerOverlay();
    typeof (props.onSubmit) === 'function' && props.onSubmit(e, updated,mode)

  }

  const onDeleteMapping = (i) => {
    props.setModalFormStatusObj({text:""})
    setForm((prev)=>{
      let updated=[...prev];
      return updated.filter((_,index)=>index!==i);   
    })

  }
  
  const onAddServings = (e) => {
    props.setModalFormStatusObj({text:""})
    let items = {
      id: null,  
      kind:'item',
      itemType: null,
      itemName:null,
      quantity: null,
      important: false,
    }

    setForm((prev)=>{
      let updatedForm=[...prev];
      return [...updatedForm,items]
    })
  }

 const fetchItemList = useCallback(async () => {
  try {
    const itemList = props.data?.itemList || [];
    if(!catPol.length){

      const catAggres = await APIEndpoint.get('main/categories/aggregate');
      if(catAggres && catAggres.success){
        const catOptions = [];
        const matchedCatIds = new Set();
        
        catAggres?.subCategories?.forEach((sc, index) => {
          const foundCat = catAggres?.categories?.find(ct => ct.catId === sc.catId);
          if (foundCat) {
            catOptions.push({
              key: `sub-${index}`,
              catId: sc.catId,
              subCatId: sc.subCatId,
              label: `${foundCat.catName} > ${sc.name}`,
              value:sc.subCatId?sc.subCatId:sc.catId
            });
            matchedCatIds.add(foundCat.catId);
          }
        });

        catAggres?.categories?.forEach((cat, index) => {
          if (!matchedCatIds.has(cat.catId)) {
            catOptions.push({
              key: `cat-${index}`,
              catId: cat.catId,
              subCatId: null,
              label: cat.catName,
              value:cat.catId
            });
          }
        });
      
        setCatPol(catOptions);
      }
    }
    if(!itemsList.length){
    setItemsList(itemList);
    }

    const form_data = props.data?.map_data?.items?.map((en,index) => {
      const { id, kind, name, path,itemType } = en.target;
      return {
        id,
        kind,
        ...(kind === 'item' 
          ? { itemName: name } 
          : { 
              category: {key:index, catId: id, label: name,value:id }, 
              ...(path[0]?{subCategory: { key:index,catId:id,subCatId: path[0].id, label: path[0].name,value:path[0].id }}:{} )
            }
        ),
        itemType: itemType,
        quantity: en.quantity,
        important: en.important,
      };
    }) || [];
    

    setForm(form_data);

  } catch (error) {
    console.error("Failed to fetch item list:", error); 
  }
}, [ props.data]); 


  const onClose = (e) => {
    removeContainerOverlay();
    props.onClose();
  }

  const removeContainerOverlay = () => {
    /**
     * Remove overlay to parent class
     */
    (document.querySelectorAll('.content-container')[0]).classList.remove('modal-overlay-bg2');
  };
 
  const handleChange = (e, index = null,source=null) => {

    props.setModalFormStatusObj({text:""})
    if (!e) {
      setForm(prevForm => {
        const updatedForm = [...prevForm];
        updatedForm[index] = {
          ...updatedForm[index],
          id: null,
          itemName: null,
          category:null,
          itemType: null,
        };
        return updatedForm;
      });
      return;
    }

    let eventName;
    if (!e.target && source === 'itemName') {
      eventName = 'itemName';
    } else if (!e.target && source === 'category') {
      eventName = 'category';
    } else {
      eventName = e.target.name.replace(/[0-9]/g, '');
    }
    const value = e.target?.value ?? e.value ?? null;

    setForm(prevForm => {
      const updatedForm = [...prevForm];

      if (eventName === 'itemName') {
        const found = itemsList.find(obj => obj.itemId === Number(value));
        if (found) {
          updatedForm[index] = {
            ...updatedForm[index],
            id: found.itemId,
            itemName: found.itemName,
            itemType: found.itemType,
            path:[] 
          };
        }
      }
      else if(eventName === 'category'){
      const foundItem=catPol?.find(item=>item.value===Number(value))
      if(foundItem){
        updatedForm[index] = {
          ...updatedForm[index],
          category: foundItem,
        };
      }
      }
      else if (eventName === 'important') {
        updatedForm[index] = {
          ...updatedForm[index],
          important: !updatedForm[index].important,
        };
      }
      else if (eventName === 'type') {
        updatedForm[index] = {
          ...updatedForm[index],
          kind: value,
          itemName:null,
          category:null
        };
      }
 
      else {
        updatedForm[index] = {
          ...updatedForm[index],
          [eventName]: Number(value),
        };
      }
  
      return updatedForm;
    });
  };
  
  return (
    <Mapping
      data={props.data}
      onClose={onClose}
      onAddServings={onAddServings}
      onDeleteMapping={onDeleteMapping}
      itemList={itemsList}
      itemListArray={itemListArray}
      catPol={catPol}
      form={form}
      loading={loading}
      setLoading={setLoading}
      handleChange={handleChange}
      onSubmit={onSubmit}
      setModalFormStatusObj={props.setModalFormStatusObj}
      modalFormStatusObj={props.modalFormStatusObj}>
    </Mapping>
  )
}